"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistStepVisibility = void 0;
var TrackingChecklistStepVisibility;
(function (TrackingChecklistStepVisibility) {
    TrackingChecklistStepVisibility[TrackingChecklistStepVisibility["ALWAYS"] = 0] = "ALWAYS";
    TrackingChecklistStepVisibility[TrackingChecklistStepVisibility["WHEN_INVALID"] = 1] = "WHEN_INVALID";
})(TrackingChecklistStepVisibility = exports.TrackingChecklistStepVisibility || (exports.TrackingChecklistStepVisibility = {}));
